import React from 'react';
import Step1 from './steps/step1';
import Step2 from './steps/step2';
import Step3 from './steps/step3';
import Step4 from './steps/step4';
import Step5 from './steps/step5';
import Step6 from './steps/step6';
import Step7 from './steps/step7';
import Step8 from './steps/step8';
import Header from './elements/header';
import {ConnectState} from './zviz3/Connect';

class App extends React.Component {

    render() {
        return (<div className={'seehi_container seehi_size_'+this.props.renderSize}>
            <div className="seehi_header">
                <Header />
                <h1>Subsidieregeling energiebesparing eigen huis (SEEH)</h1>
            </div>
            <div id="seehi_step1">
                <Step1 /> 
                <div className="seehi_continue"></div>
            </div>
            <div id="seehi_step2">
                <Step2 />
                <div className="seehi_continue"></div>
            </div>
            <div id="seehi_step3">
                <Step3 />
                <div className="seehi_continue"></div>
            </div>
            <div id="seehi_step4">
                <Step4 />
                <div className="seehi_continue"></div>
            </div>
            <div id="seehi_step5">
                <Step5 />
                <div className="seehi_continue"></div>
            </div>
            <div id="seehi_step6">
                <Step6 />
                <div className="seehi_continue"></div>
            </div>
            <div id="seehi_step7">
                <Step7 />
                <div className="seehi_continue"></div>
            </div>
            <div id="seehi_step8">
                <Step8 />
                <div className="seehi_continue"></div>
            </div>
        </div>);
    }
}

export default ConnectState(App, 'renderSize');



// WEBPACK FOOTER //
// ./src/App.js